import axios from "../api";
// Mint a Stripe customer portal link. The backend answers 303 + URL rather than
// redirecting, so the caller decides how to open it. Null when it declines to
// mint one (no Stripe customer), so callers can say so instead of opening
// nothing.
export const createCustomerPortalSession = async () => {
    const res = await axios.post("/payments/create-customer-portal-session");
    return res.data?.status === 303 && res.data?.url ? res.data.url : null;
};
//# sourceMappingURL=createCustomerPortalSession.js.map